import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './info-constants';

export const data = handleActions(
  {
    [actionTypes.GET_CUSTOMER_INFO_REQUEST]: () => ({}),
    [actionTypes.GET_CUSTOMER_INFO_SUCCESS]: (state, { payload }) => payload.details.customer,
  },
  {},
);

export const payer = handleActions(
  {
    [actionTypes.GET_CUSTOMER_INFO_REQUEST]: () => ({}),
    [actionTypes.GET_CUSTOMER_INFO_SUCCESS]: (state, { payload }) => payload.details.payer || state,
  },
  {},
);

export const isLoading = handleActions(
  {
    [actionTypes.GET_CUSTOMER_INFO_REQUEST]: () => true,
    [combineActions(
      actionTypes.GET_CUSTOMER_INFO_SUCCESS,
      actionTypes.GET_CUSTOMER_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_CUSTOMER_INFO_REQUEST,
      actionTypes.GET_CUSTOMER_INFO_SUCCESS,
    )]: () => ({}),
    [actionTypes.GET_CUSTOMER_INFO_FAILURE]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  data,
  payer,
  isLoading,
  error,
});
